export default "__VITE_ASSET__C$ruq8F2__"